import { useMotionValue } from "framer-motion";
import { useAtom } from "jotai";
import React, { useEffect } from "react";
import {
  currentUserAtom,
  onlinesAtom,
  useMouseRef,
  useScrollRef,
} from "../jotai/atoms";
import { usePresence } from "../liveblocks/presences";
import { Presence } from "../types";
import {
  gridToPixelPosition,
  gridToPixelSize,
  pixelToGridPosition,
  pixelToGridSize,
} from "../utils/gridPosition";
import ViewportRect from "./Viewport";

function ViewportList() {
  const mousePositionRef = useMouseRef();
  const [currentUser] = useAtom(currentUserAtom);
  const [onlines] = useAtom(onlinesAtom);
  const currentUserX = useMotionValue(0);
  const currentUserY = useMotionValue(0);
  const [viewports, updatePresence] =
    usePresence<Presence["viewport"]>("viewport");

  const scroll = useScrollRef();

  // send current user viewport rectangle
  useEffect(() => {
    if (!mousePositionRef) return;
    function updateViewport() {
      const viewport = {
        position: gridToPixelPosition(
          pixelToGridPosition({
            x: document.documentElement.scrollLeft,
            y: document.documentElement.scrollTop,
          })
        ),
        size: gridToPixelSize(
          pixelToGridSize({
            width: window.innerWidth,
            height: window.innerHeight,
          })
        ),
      };
      updatePresence({ viewport });
    }

    function onScroll() {
      if (!scroll?.current) return;
      updateViewport();
    }

    function onResize() {
      updateViewport();
    }

    window.addEventListener("scroll", onScroll);
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onResize);
    };
  }, [currentUserX, currentUserY, mousePositionRef, scroll, updatePresence]);

  return (
    <ul>
      {[...onlines].map((uid: string) => {
        return (
          <li key={uid}>
            <ViewportRect
              userId={uid}
              isSelf={currentUser!.id === uid}
              viewport={viewports[uid]}
            ></ViewportRect>
          </li>
        );
      })}
    </ul>
  );
}

export default React.memo(ViewportList);
